import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Frontend error monitoring — only in production builds so local dev doesn't spam Sentry.
// sendDefaultPii is OFF: this is an NDIS app, so we don't ship participant/IP PII to a
// third party by default (flip to true if you want IP/user context on events).
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://430119a1241053a1f665bcde45e8f0b9@o4511511351787520.ingest.us.sentry.io/4511511354015744',
    environment: 'production',
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>);
